import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  filtersOpen: false,
  msalToken: ''
}

const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setFiltersOpen: (state, action) => {
      state.filtersOpen = action.payload
    },
    setMsalToken: (state, action) => {
      state.msalToken = action.payload
    }
  }
})

export const {setFiltersOpen, setMsalToken} = filtersSlice.actions

// Selectors with null-safe defaults
export const selectFiltersOpen = (state) => state.filters?.filtersOpen ?? false
export const selectMsalToken = (state) => state.filters?.msalToken ?? ''

export default filtersSlice.reducer
